/* Mouse dragging complements native touch/trackpad scrolling. */
(() => {
  if (window.MarbilyCollectionDrag) { window.MarbilyCollectionDrag(); return; }
  const states = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root = document) {
    root.querySelectorAll('[data-mh-collection-drag]').forEach(track => {
      if (states.has(track)) return;
      const controller = new AbortController(), options = { signal: controller.signal };
      let pointer = null, frame = 0, suppressClick = false, clickTimer = 0;
      const stop = () => { cancelAnimationFrame(frame); frame = 0; track.classList.remove('is-dragging'); };
      const finish = (event, cancelled = false) => {
        if (!pointer || event.pointerId !== pointer.id) return;
        const state = pointer; pointer = null;
        if (track.hasPointerCapture(state.id)) track.releasePointerCapture(state.id);
        if (!state.dragging) return;
        suppressClick = !cancelled;
        clearTimeout(clickTimer); clickTimer = setTimeout(() => { suppressClick = false; }, 250);
        if (cancelled || reduced.matches || performance.now() - state.time > 90) { stop(); return; }
        let velocity = state.velocity, previous = performance.now();
        const glide = time => {
          const elapsed = Math.min(32, time - previous); previous = time;
          const before = track.scrollLeft;
          track.scrollLeft += velocity * elapsed;
          velocity *= Math.pow(0.92, elapsed / 16);
          if (Math.abs(velocity) < 0.02 || Math.abs(track.scrollLeft - before) < 0.1) { stop(); return; }
          frame = requestAnimationFrame(glide);
        };
        frame = requestAnimationFrame(glide);
      };
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        stop(); suppressClick = false; clearTimeout(clickTimer);
        pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: track.scrollLeft, last: track.scrollLeft, time: performance.now(), velocity: 0, dragging: false };
      }, options);
      track.addEventListener('pointermove', event => {
        if (!pointer || event.pointerId !== pointer.id) return;
        const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
        if (!pointer.dragging) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { pointer = null; return; }
          pointer.dragging = true; track.setPointerCapture(event.pointerId); track.classList.add('is-dragging');
        }
        event.preventDefault();
        track.scrollLeft = pointer.scroll - dx;
        const now = performance.now(), elapsed = Math.max(1, now - pointer.time);
        pointer.velocity = Math.max(-2, Math.min(2, (track.scrollLeft - pointer.last) / elapsed));
        pointer.last = track.scrollLeft; pointer.time = now;
      }, options);
      track.addEventListener('pointerup', event => finish(event), options);
      track.addEventListener('pointercancel', event => finish(event, true), options);
      track.addEventListener('lostpointercapture', event => finish(event, true), options);
      track.addEventListener('pointerleave', () => { if (pointer && !pointer.dragging) pointer = null; }, options);
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      track.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false;
      }, { ...options, capture: true });
      track.addEventListener('wheel', stop, { ...options, passive: true });
      track.addEventListener('keydown', stop, options);
      states.set(track, () => { pointer = null; stop(); clearTimeout(clickTimer); controller.abort(); });
    });
  }
  window.MarbilyCollectionDrag = setup;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true }); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-mh-collection-drag]').forEach(track => { states.get(track)?.(); states.delete(track); }));
})();
